import {Pipe, PipeTransform} from '@angular/core';
import {ComparatorService} from "../../services/comparator-service";
import {RechtMasterListEntry} from "../../../core/gb-api/model/rechtMasterListEntry";
import {PfandrechtMasterDetailEntryMeta, StandardrechtMasterDetailEntryMeta} from '../../../core/gb-api';

@Pipe({
  name: 'orderByRechtId'
})

export class OrderByRechteIdPipe implements PipeTransform {

  public constructor(private comperatorService: ComparatorService) {
  }

  transform(array, ascending = true): RechtMasterListEntry[] | StandardrechtMasterDetailEntryMeta[] | PfandrechtMasterDetailEntryMeta[] {
    if (ascending) {
      return Array.from(array).sort((a: RechtMasterListEntry, b: RechtMasterListEntry) => {
        return this.orderByComparator(a, b);
      });
    } else {
      return Array.from(array).sort((a: RechtMasterListEntry, b: RechtMasterListEntry) => {
        return this.orderByComparator(b, a);
      });
    }
  }

  private orderByComparator(a: RechtMasterListEntry, b: RechtMasterListEntry): number {
    return this.comperatorService.rechtIdVersionComparator(a.rechteId, b.rechteId, a.version.histInfo, b.version.histInfo,
      a.version.erstellzeitpunkt, a.version.erstellzeitpunkt);
  }

}
